/**
 * What: Static semantic dictionaries for provider-neutral analytics aggregates.
 * Transport / data-flow: Pure in-memory constants and Zod schemas shared by adapters, formulas, and overlay validation.
 *
 */
import * as z from 'zod';
export const integrationAggregateProviderValues = [
    'shopify',
    'posthog',
    'amplitude',
    'ga4',
    'heap',
    'mixpanel',
    'google-search-console',
];
export const integrationAggregateSourceSurfaceValues = [
    'shopify_admin',
    'posthog_project',
    'amplitude_project',
    'ga4_property',
    'heap_environment',
    'mixpanel_project',
    'google_search_console_property',
];
export const integrationAggregateRecordKindValues = [
    'product_interest',
    'path_intent',
    'event_interest',
    'funnel_stage',
    'device_context',
    'geo_context',
    'traffic_source',
    'retention_context',
    'cohort_membership',
    'discovery_intent',
    'customer_evidence',
];
export const integrationAggregateGrainValues = [
    'store',
    'product',
    'path',
    'event',
    'funnel',
    'cohort',
    'campaign',
    'source_account',
    'search_query',
];
export const integrationAggregateSubjectTypeValues = [
    'aggregate',
    'anonymous',
    'identified',
    'customer',
    'linked',
    'account',
];
export const integrationAggregateIdentityStateValues = [
    'aggregate',
    'anonymous',
    'identified',
    'customer',
    'linked',
    'ambiguous',
];
export const integrationAggregateEventClassValues = [
    'view',
    'cart',
    'checkout',
    'purchase',
    'signup',
    'engagement',
    'custom',
];
export const integrationAggregateEvidenceValues = [
    'browsed',
    'purchased',
    'carted',
    'checkout_started',
    'both',
    'aggregate_only',
];
export const audienceFormulaSignalKindValues = [
    'product_interest',
    'intent_level',
    'audience_shape',
    'cohort_context',
    'discovery_intent',
    'customer_evidence',
];
export const audienceFormulaLanguageKeyValues = [
    'shopper_intelligence.product_interest',
    'shopper_intelligence.intent_level',
    'shopper_intelligence.audience_shape',
    'shopper_intelligence.cohort_context',
    'shopper_intelligence.discovery_intent',
    'shopper_intelligence.customer_evidence',
];
export const nonAdditiveMeasureKeys = ['average_position', 'conversion_rate_basis_points'];
export const integrationAggregateProviderSchema = z.enum(integrationAggregateProviderValues);
export const integrationAggregateSourceSurfaceSchema = z.enum(integrationAggregateSourceSurfaceValues);
export const integrationAggregateRecordKindSchema = z.enum(integrationAggregateRecordKindValues);
export const integrationAggregateGrainSchema = z.enum(integrationAggregateGrainValues);
export const integrationAggregateSubjectTypeSchema = z.enum(integrationAggregateSubjectTypeValues);
export const integrationAggregateIdentityStateSchema = z.enum(integrationAggregateIdentityStateValues);
export const integrationAggregateEventClassSchema = z.enum(integrationAggregateEventClassValues);
export const integrationAggregateEvidenceSchema = z.enum(integrationAggregateEvidenceValues);
export const audienceFormulaSignalKindSchema = z.enum(audienceFormulaSignalKindValues);
export const audienceFormulaLanguageKeySchema = z.enum(audienceFormulaLanguageKeyValues);
//# sourceMappingURL=vocabulary.js.map